__turbopack_context__.v({
  "banner": "EmailConfirmationBanner-module__pYi93G__banner",
  "changeLink": "EmailConfirmationBanner-module__pYi93G__changeLink",
  "imageContainer": "EmailConfirmationBanner-module__pYi93G__imageContainer",
  "imageWrapper": "EmailConfirmationBanner-module__pYi93G__imageWrapper",
  "textContainer": "EmailConfirmationBanner-module__pYi93G__textContainer",
});
